import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import i18n from 'i18n-react';

import { MobileAwareWebsiteLink } from 'components/MobileAwareWebsiteLink/MobileAwareWebsiteLink';

import { isMobileWebview } from 'helpers/isMobileWebview';
import { normalizeUrl } from 'helpers/normalizeUrl';

import { decodeHtmlEntities } from '../../helpers/decodeHtmlEntities';
import c from './_profileContact.module.scss';

export interface ProfileContactProps {
  webUrl: string | null;
  phone: string | null;
  altPhone: string | null;
  tollFree: string | null;
  fax: string | null;
  primaryContactFullName: string | null;
  primaryContactTitle: string | null;
  email: string | null;
}

export function ProfileContact({
  webUrl,
  phone,
  altPhone,
  tollFree,
  fax,
  primaryContactFullName,
  primaryContactTitle,
  email,
}: ProfileContactProps) {
  const hideWebsiteIcon = isMobileWebview();
  const normalizedWebUrl = webUrl && normalizeUrl(webUrl);

  return (
    <div className={clsx('profile-contact', c.wrapper)}>
      {normalizedWebUrl && (
        <p>
          {!hideWebsiteIcon && (
            <React.Fragment>
              <FontAwesomeIcon icon={['fas', 'link']} />{' '}
            </React.Fragment>
          )}
          {i18n.translate('directoryProfileView.website')}
          <br />
          <MobileAwareWebsiteLink url={normalizedWebUrl}>{decodeHtmlEntities(normalizedWebUrl)}</MobileAwareWebsiteLink>
        </p>
      )}

      {primaryContactFullName && (
        <p>
          {i18n.translate('directoryProfileView.contactPerson')}
          <br />
          <span className="profile-contact__value">
            {decodeHtmlEntities(primaryContactFullName)}
            <br />
            {decodeHtmlEntities(primaryContactTitle)}
          </span>
        </p>
      )}

      {phone && (
        <p>
          <FontAwesomeIcon icon={['fas', 'phone']} /> {i18n.translate('directoryProfileView.phone')}
          <br />
          <a href={`tel:${phone}`}>{phone}</a>
        </p>
      )}

      {altPhone && (
        <p>
          <FontAwesomeIcon icon={['fas', 'phone']} /> {i18n.translate('directoryProfileView.altPhone')}
          <br />
          <a href={`tel:${altPhone}`}>{altPhone}</a>
        </p>
      )}

      {tollFree && (
        <p>
          <FontAwesomeIcon icon={['fas', 'phone']} /> {i18n.translate('directoryProfileView.tollFree')}
          <br />
          <a href={`tel:${tollFree}`}>{tollFree}</a>
        </p>
      )}

      {fax && (
        // Plain text: a fax number can't be called.
        <p>
          <FontAwesomeIcon icon={['fas', 'fax']} /> {i18n.translate('directoryProfileView.fax')}
          <br />
          <span className="profile-contact__value">{fax}</span>
        </p>
      )}

      {email === 'N/A' ? (
        <p>
          <FontAwesomeIcon icon={['fas', 'envelope']} /> {i18n.translate('directoryProfileView.email')}
          <br />
          <span className="profile-contact__value">{'N/A'}</span>
        </p>
      ) : (
        email && (
          <p>
            <FontAwesomeIcon icon={['fas', 'envelope']} /> {i18n.translate('directoryProfileView.email')}
            <br />
            <a href={`mailto:${email}`}>{decodeHtmlEntities(email)}</a>
          </p>
        )
      )}
    </div>
  );
}
